import { useState } from 'react';
import RewardsLeaderBoard from './../../presentation/rewardsLeaderBoard/RewardsLeaderBoard.jsx';

const RewardsLeaderBoardContainer = ({
	recognitionPointsLeaderboard,
	recognitionPointsBySubCompanyLeaderboard,
	isLoading,
}) => {
	const [selectedFilter, setSelectedFilter] = useState('all');

	// The sub-company leaderboard comes back null when the user doesn't qualify
	// for it, which is what hides the filter.
	const showSubCompanyFilter = Boolean(recognitionPointsBySubCompanyLeaderboard);
	const currentFilter = showSubCompanyFilter ? selectedFilter : 'all';

	return (
		<div>
			<RewardsLeaderBoard
				isLoading={isLoading}
				selectedFilter={currentFilter}
				setSelectedFilter={setSelectedFilter}
				showSubCompanyFilter={showSubCompanyFilter}
				leaderBoard={recognitionPointsLeaderboard}
				branchLeaderboard={recognitionPointsBySubCompanyLeaderboard}
			/>
		</div>
	);
};

export default RewardsLeaderBoardContainer;
